module.exports = __webpack_public_path__ + "img/20191021163239060.afb1b5e4.jpg";